import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CartItem = ({ item, onUpdateQuantity, onRemove, onSaveForLater }) => {
  const handleQuantityChange = (newQuantity) => {
    if (newQuantity < 1) return;
    onUpdateQuantity(item?.id, newQuantity);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-UG', {
      style: 'currency',
      currency: 'UGX',
      minimumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-4 p-4 bg-card border border-border rounded-lg">
      {/* Product Image */}
      <div className="flex-shrink-0">
        <Link to={`/service-details?id=${item?.id}`}>
          <div className="w-20 h-20 lg:w-24 lg:h-24 rounded-lg overflow-hidden bg-muted">
            <Image
              src={item?.image}
              alt={item?.name}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
            />
          </div>
        </Link>
      </div>
      {/* Product Details */}
      <div className="flex-1 min-w-0">
        <Link 
          to={`/service-details?id=${item?.id}`}
          className="block hover:text-primary transition-colors"
        >
          <h3 className="text-lg font-semibold text-foreground mb-1 line-clamp-2">
            {item?.name}
          </h3>
        </Link>
        <p className="text-sm text-muted-foreground mb-2">{item?.category}</p>
        
        {item?.specifications && (
          <div className="text-sm text-muted-foreground mb-2">
            <p className="line-clamp-2">{item?.specifications}</p>
          </div>
        )}

        {item?.deliveryTime && (
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>Delivery: {item?.deliveryTime}</span>
          </div>
        )}
      </div>
      {/* Quantity Controls */}
      <div className="flex items-center gap-3">
        <div className="flex items-center border border-border rounded-lg">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleQuantityChange(item?.quantity - 1)}
            disabled={item?.quantity <= 1}
            className="h-8 w-8 p-0"
          >
            <Icon name="Minus" size={14} />
          </Button>
          <span className="px-3 py-1 text-sm font-medium min-w-[3rem] text-center">
            {item?.quantity}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleQuantityChange(item?.quantity + 1)}
            className="h-8 w-8 p-0"
          >
            <Icon name="Plus" size={14} />
          </Button>
        </div>
      </div>
      {/* Price */}
      <div className="text-right">
        <div className="text-lg font-semibold text-foreground">
          {formatPrice(item?.price * item?.quantity)}
        </div>
        <div className="text-sm text-muted-foreground">
          {formatPrice(item?.price)} each
        </div>
      </div>
      {/* Actions */}
      <div className="flex lg:flex-col gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onSaveForLater(item?.id)}
          className="flex items-center gap-1 text-muted-foreground hover:text-foreground"
        >
          <Icon name="Heart" size={14} />
          <span className="hidden lg:inline">Save</span>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRemove(item?.id)}
          className="flex items-center gap-1 text-error hover:text-error/80"
        >
          <Icon name="Trash2" size={14} />
          <span className="hidden lg:inline">Remove</span>
        </Button>
      </div>
    </div>
  );
};

export default CartItem;